const targeting = '/survey/targeting/:surveyId';
const targetingPeeq = '/survey/targeting-prodege/:surveyId';
const questionnaire = '/survey/questionnaire/:surveyId';
const questionnaireAdvancedLogic =
  '/survey/questionnaire/:surveyId/advanced-logic';
const questionnaireAdvancedQuotaLogic =
  '/survey/questionnaire/:surveyId/advanced-quota-logic';
const questionnaireDisqualifyLogic =
  '/survey/questionnaire/:surveyId/disqualify-logic';
const questionnaireTheme = '/survey/questionnaire/:surveyId/theme';
const thirdParty = '/survey/third-party/:surveyId';
const link = '/survey/link/:surveyId/share';
const summary = '/survey/summary/:surveyId';
const settings = '/survey/settings/:surveyId';
const checkout = '/survey/confirm/:surveyId';
const hiddenVariables = '/survey/questionnaire/:surveyId/hidden-variables';
const displayLogic = '/survey/questionnaire/:surveyId/display-logic';
export const SURVEY_NAME_MAX_LENGTH = 128;
export const SURVEY_PAGE_WIDTH = 1240;

export function createAllRouteCombinations(routes) {
  // create all combinations between the routes
  return routes.flatMap((fromRoute) =>
    routes.map((toRoute) => ({
      fromStartsWith: fromRoute,
      toStartsWith: toRoute,
    })),
  );
}

export function getSurveyLocationResetExceptionRules() {
  return createAllRouteCombinations([
    targeting,
    targetingPeeq,
    questionnaire,
    questionnaireAdvancedLogic,
    questionnaireAdvancedQuotaLogic,
    questionnaireDisqualifyLogic,
    questionnaireTheme,
    link,
    thirdParty,
    summary,
    settings,
    checkout,
    hiddenVariables,
    displayLogic,
  ]);
}

export function getSurveyLocationResetExceptionRulesForVersionHistory() {
  return createAllRouteCombinations([
    questionnaire,
    questionnaireAdvancedLogic,
    questionnaireAdvancedQuotaLogic,
    hiddenVariables,
    displayLogic,
  ]).filter(
    ({ fromStartsWith, toStartsWith }) => fromStartsWith !== toStartsWith,
  );
}

export const HEADER_HEIGHT = 44;
